module.exports = __webpack_public_path__ + "static/media/1_BAINS_Archi_genf_rénov_1.e9452970.jpg";